import styled from 'styled-components/macro';

import { colors } from '../../styles/vars';

const Wrapper = styled.div`
  display: flex;
  margin-top: 10px;
  font-size: 14px;
  color: ${props => (props.invalid ? colors['dusty-orange'] : colors.algae)};

  .copyright & {
    font-size: 10px;
  }
`;

export default Wrapper;
